import { useEffect } from 'react';

type ElementRef<T extends HTMLElement = HTMLElement> = {
  current: T | null;
};
// RAT binding implementation for click events
// https://confluence.rakuten-it.com/confluence/pages/viewpage.action?pageId=2617778545
const useRatBindClickComponent = <T extends HTMLElement>(node: ElementRef<T>) => {
  useEffect(() => {
    if (node.current && window.RAT) {
      window.RAT.bind(window.RAT.$Selector(node.current));
    }
  }, []);
};

export default useRatBindClickComponent;
